export enum SuggestionsSurfaceVariant {
  LIST = 'list',
  BOARD = 'board',
}
